export default "__VITE_ASSET__DzUd5qny__"